module.exports = __webpack_public_path__ + "media/images/emblems/Bossonens-coat_of_arms-62baa1ee50815ff396434bcccf961942.svg";